import { Box, styled, Typography } from "@mui/material";
import MuiTimelineContent from "@mui/lab/TimelineContent";
import MuiTimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import MuiTimelineItem from "@mui/lab/TimelineItem";
import {
    LIMITED_WIDTH,
    TEXT_STYLE,
} from "./Factory/GameTimelineFactory.styles";
import MuiTimelineConnector from "@mui/lab/TimelineConnector";

export const TimelineSubline = styled(Typography)({
    textAlign: "left",
    ...TEXT_STYLE,
    ...LIMITED_WIDTH,
    color: "var(--community-color-secondary-text)",
    fontSize: "12px",
});

export const TimelineContentContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
});

export const TimelineContent = styled(MuiTimelineContent)({
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
});

export const TimelineOppositeContent = styled(MuiTimelineOppositeContent)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 12px",
});

export const TimelineItemElementInvisible = styled(MuiTimelineItem)({
    maxHeight: 0,
    minHeight: 0,
});

export const TimelineItemElement = styled(MuiTimelineItem)({
    padding: "0",
    minHeight: "50px",
});

export const ShorterTimelineItem = styled(TimelineItemElement)({
    minHeight: "40px",
});

export const ShortestTimelineItem = styled(TimelineItemElement)({
    minHeight: "12px",
});

export const TimelineItemRightColumn = styled(Box)({});
export const TimelineConnector = styled(MuiTimelineConnector)({
    backgroundColor: "var(--community-color-light-steal-blue)",
});
